export const ACTION_TYPES = {
  LOGIN: Symbol("LOGIN"),
  SET_LOGIN_STATE: Symbol("SET_LOGIN_STATE"),
  SET_USER_INFO: Symbol("SET_USER_INFO"),
};
